import db, { initDB } from '../db';
import { getAudioUrl } from './audio';
import { loadPlan, sectionForChapter } from './plan';

const PLAN_TAGS = new Set([
  'plan',
  'ot',
  'nt',
  'poetry',
  'old_testament',
  'new_testament',
]);

export function chapterToHash(chapter) {
  if (!chapter || chapter.bookId == null || chapter.chapter == null) return '';
  const base = `#${chapter.bookId}:${chapter.chapter}`;
  return chapter.fromPlan || chapter.planSection ? `${base}:plan` : base;
}

export function parseChapterHash(hash) {
  const m = String(hash || '').replace(/^#/, '').match(/^(\d+):(\d+)(?::([a-z_]+))?$/i);
  if (!m) return null;
  const tag = m[3] ? m[3].toLowerCase() : '';
  return {
    bookId: Number(m[1]),
    chapter: Number(m[2]),
    fromPlan: PLAN_TAGS.has(tag),
  };
}

export function writeChapterHash(chapter) {
  const next = chapterToHash(chapter);
  if (!next) return;
  if (window.location.hash === next) return;
  window.history.replaceState(null, '', next);
}

/** Same path as tapping the chapter in the grid: load it and start playing. */
export async function restoreChapterFromHash(setCurrentChapter, setIsPlaying, updateSession, currentChapter) {
  const parsed = parseChapterHash(window.location.hash);
  if (!parsed) return false;
  if (
    currentChapter &&
    Number(currentChapter.bookId) === parsed.bookId &&
    Number(currentChapter.chapter) === parsed.chapter &&
    Boolean(currentChapter.fromPlan || currentChapter.planSection) === parsed.fromPlan
  ) {
    return false;
  }
  await initDB();
  const book = await db.books.get(parsed.bookId);
  if (!book || parsed.chapter < 1 || parsed.chapter > book.chapters) return false;
  let planSection;
  if (parsed.fromPlan) {
    try {
      const plan = await loadPlan();
      const section = sectionForChapter(plan, book.id, parsed.chapter);
      if (section) planSection = section.id;
    } catch (e) {
      /* play without plan mode */
    }
  }
  const chapterData = {
    bookId: book.id,
    book: book.name,
    chapter: parsed.chapter,
    url: getAudioUrl(book.id, book.name, parsed.chapter),
    ...(planSection ? { fromPlan: true, planSection } : {}),
  };
  setCurrentChapter(chapterData);
  setIsPlaying(true);
  if (updateSession) updateSession(chapterData);
  return true;
}
